import { IconButton } from '@mui/material'
import React from 'react'
import { reportSearch } from '../../../../../assets/images/icons'
import { MuiImage } from '../../../../../components'

const SearchReportButton = ({ id = '' }) => {
  const buttonClickHandler = () => {
    const element = document.getElementById(id)
    if (!element) return
    element.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <IconButton onClick={buttonClickHandler}>
      {/* <MuiImage src={reportSearch} />aaaaaa */}
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path d="M9.99996 17.5833L4.77246 12.3558L5.5385 11.5897L9.45829 15.5176V2.40869H10.5416V15.5095L14.4614 11.5897L15.2275 12.3558L9.99996 17.5833Z" fill="#686867"/>
      </svg>
    </IconButton>
  )
}

export default SearchReportButton
